import {
  Message,
  SendMessageOptions,
  sendMessage,
} from '@showbie/utilities/message';

export function createSendMessage({
  targetWindow,
  targetOrigin,
  shouldUseWebKit = false,
  webkitHandlerName = '',
}: Omit<SendMessageOptions, 'message'>) {
  return function sendMessageWithMessageOnly(message: Message) {
    sendMessage({
      targetWindow,
      message,
      targetOrigin,
      shouldUseWebKit,
      webkitHandlerName,
    });
  };
}
